import { service } from "../../../constants/pages";

const ServiceCard = ({
  title,
  content,
  img,
}: {
  title: string;
  content: string;
  img: string;
}) => {
  return (
    <div className="group flex flex-col h-full bg-primary-50/20 rounded-2xl p-6 shadow-md transition-all duration-300 hover:shadow-xl hover:translate-y-[-5px]">
      {/* Icon Container */}
      <div className="mb-6">
        <img alt={title} src={img} className="w-8 h-8 relative" />
      </div>

      {/* Content */}
      <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-orange-500 transition-colors duration-300">
        {title}
      </h3>

      <p className="text-gray-900 ">{content}</p>
    </div>
  );
};

export default function ServicesSection() {
  // Limit to 6 services
  const limitedServices = service.ikons.slice(0, 9);

  return (
    <section className="bg-customgreen py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-6 xl:px-0">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-primary-900">
            Our Services
          </h2>
          <p className="text-primary-900 text-lg sm:text-xl">
            Set up organisation and companies from incorporation, Website
            development, Register it with regulatory bodies, Train Staffs and
            introduce new companies to our database.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {limitedServices.map((ikon) => (
            <ServiceCard
              key={ikon.title}
              title={ikon.title}
              content={ikon.content}
              img={ikon.img}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
